import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ColorAnimationService } from '@ethic/shared/color-animation';
import { filter, take } from 'rxjs/operators';
import { Config } from '../../config';
import { NotificationService } from '../shared/services/notification.service';

@Component({
  selector: 'lgn-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  emailControl = new FormControl('', [Validators.email]);

  constructor(
    public config: Config,
    public notificationService: NotificationService,
    public colorAnimation: ColorAnimationService
  ) {
    this.notificationService.clean();
  }

  ngOnInit(): void {
    this.emailControl.valueChanges
      .pipe(
        filter(() => this.emailControl.dirty),
        take(1)
      )
      .subscribe(() => {
        this.notificationService.clean();
      });
  }
}
